import { useState, useRef } from "react"
import Dropdown from 'react-bootstrap/Dropdown';
//import UserActiviti from '../aside/UserActiviti'
import {useAuth} from "../auth/request/AuthProvider";
import { Modal, FloatingLabel, Form, InputGroup, Card } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { axiosInstance } from "../helpers/axiosInstance";

const passwordValidation = Yup.object({
    apass: Yup.string().required("La contraseña actual es necesaria"), //apass
    npass: Yup.string() //npass
        .min(5, "Mínimo 5 carácter")
        // .matches(passwordRules, { message: "Contraseña debil" }),
        .required("Escribe la nueva contraseña"),
    cpass: Yup.string()//cpass
        .oneOf([Yup.ref("npass"), null], "No coinciden")
        .required("Ambas contraseñas deben coincidir"),
})

export default function BottomMenu() {

    const user = useAuth();
    const auth = JSON.parse(sessionStorage.getItem("user"));
    const [show, setShow] = useState(false);


    /**
     * @param auth información de usuario
     * @param auth.usuario.avatar avatar de usuario
     * */
    return (
        <>
            <style type="text/css">
                {`

                    .dropdown-toggle{
                        padding: 0.75rem !important;
                    }
                    .dropdown-toggle::after {
                        display: none !important; 
                    }

                `}
            </style>
            <div className="aside-footer d-flex flex-column align-items-center flex-column-auto" id="aside_footer">
                {/*<div className="d-flex align-items-center mb-3">*/}
                {/*    <button className="btn btn-icon btn-active-color-primary btn-color-gray-500 btn-active-light" onClick={() => setShowModal(true)}>*/}
                {/*        <i className="ki-outline ki-chart-line-up fs-2 fs-lg-1"></i>*/}
                {/*    </button>*/}
                {/*</div>*/}
                {/*<UserActiviti*/}
                {/*    showModal={showModal}*/}
                {/*    onClose={() => setShowModal(false)}*/}
                {/*></UserActiviti>*/}
                <div className="d-flex align-items-center mb-10">
                    {/* Dropdown : Menu */}
                    <Dropdown align={'end'} placement={'top-start'}>
                        <Dropdown.Toggle bsPrefix={'btn p-0 fs-sm-base'} as={'button'} type={'button'}>
                            <div className="symbol symbol-40px">
                                <span className={"symbol-label fw-bold " + auth.usuario.avatar}>
                                    {auth.usuario.avatar}
                                </span>
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            renderOnMount={true}
                            flip={true}
                            bsPrefix={'menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px'}>
                            <div className={'menu-item px-3'}>
                                <Dropdown.Item bsPrefix={"menu-content d-flex align-items-center px-3"}>
                                    <div className={"symbol symbol-50px me-5 "}>
                                    <span
                                        className={"symbol-label fw-bold " + auth.usuario.avatar}>{auth.usuario.avatar}</span>
                                    </div>
                                    <div className="d-flex flex-column overflow-hidden">
                                        <div className="fw-bold d-flex align-items-center fs-5 text-capitalize">
                                            {auth.usuario.nombre}
                                        </div>
                                        <button type={'button'} className="btn p-1 fw-semibold text-muted fs-7 overflow-hidden">
                                            {auth.usuario.email}
                                        </button>
                                    </div>
                                </Dropdown.Item>
                            </div>
                            <div className={"separator my-2"}></div>
                            <div className={'menu-item px-5'}>
                                <Dropdown.Item eventKey="3" bsPrefix="menu-link px-5" onClick={() => setShow(true)}>
                                    Cambiar contraseña
                                </Dropdown.Item>
                            </div>
                            <div className={"separator my-2"}></div>
                            <div className={'menu-item px-5'}>
                                <Dropdown.Item eventKey="2" bsPrefix="menu-link px-5" onClick={() => user.logOut()}>
                                    Salir
                                </Dropdown.Item>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            {/* Modal : Cambiar contraseña */}
            <ChangePassword show={show} setShow={setShow} />
        </>
    );
}

function ChangePassword({
    show,
    setShow,
}){

    const [showNewP, setShowNewP] = useState(false);
    const [showConfirmP, setShowConfirmP] = useState(false);
    const user = useAuth();
    const inputRef = useRef(null);

    function onSubmit(values) {
       axiosInstance.patch('/staff/cpass',values)
           .then(
               (res) => {
                if (res.status === 200) {
                    formik.resetForm();
                    setShow(false);
                    user.logOut();
                }
            }).catch((error) => {
                formik.setFieldError(`${error.response.data.errors[0].input}`, `${error.response.data.errors[0].details}`);
       });
    }


    //////////////// formik maneja el formulario ////////////////
    const formik = useFormik({
        initialValues: {
            apass: "", //apass
            npass: "", //npass
            cpass: "", //cpass
        },
        validationSchema : passwordValidation,
        onSubmit
    });

    //////////////// La propiedad autofocus se pierde con las animaciones del modal, se tiene que volver a hacer
    //////////////// después de que el modal se haya montado
    const handleEntered = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    return(
        <>
            <style type={'text/css'}>
                {`
                    .form-floating > label::after {
                        background-color: var(--bs-gray-100)!important;
                    }
                    
                    .btn-icon:focus{
                        background-color: var(--bs-secondary);
                    }
                    
                    .btn.btn-icon.pass {
                        height: calc(1.5em + 1.55rem + 6px);
                    }
                `}
            </style>
            <Modal show={show} onHide={() => setShow(false)} fullscreen={true} onEntered={handleEntered}>
                <Modal.Header closeButton>
                    <div className={'active rotate'}>
                        <i className="bi bi-key-fill fs-3qx text-primary rotate-90"></i>
                    </div>
                    <Modal.Title>Cambiar contraseña</Modal.Title>
                </Modal.Header>
                <Modal.Body className={'align-content-center'}>
                    <Card className="mw-md-50 my-auto mx-auto">
                        {/*{*/}
                        {/*    message ? (*/}
                        {/*        <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6">*/}
                        {/*            <i className="ki-duotone ki-information fs-2tx text-warning me-4">*/}
                        {/*                <span className="path1"></span>*/}
                        {/*                <span className="path2"></span>*/}
                        {/*                <span className="path3"></span>*/}
                        {/*            </i>*/}
                        {/*            <div className="d-flex flex-stack flex-grow-1">*/}
                        {/*                <div className="fw-semibold">*/}
                        {/*                    <h4 className="text-gray-900 fw-bold">{message}!</h4>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    ) : (*/}
                                <Card.Header className="border-0 min-h-35px align-content-center">
                                    <h3>Identificación</h3>
                                </Card.Header>
                        {/*    )*/}
                        {/*}*/}

                        <Card.Body className="pt-7">
                            {/* FORM : Cambiar contraseña */}
                            <Form id={'changePassword'} onSubmit={formik.handleSubmit}>
                                <div className="mb-1">
                                    <FloatingLabel controlId="floatingPassword" label="Contraseña actual"
                                                   bsPrefix={"form-floating mb-5 text-gray-700"}>
                                        <Form.Control
                                            ref={inputRef}
                                            type="password"
                                            tabIndex={1}
                                            autoComplete={'off'}
                                            placeholder="Password"
                                            className={"form-control form-control-solid"}
                                            name="apass"
                                            value={formik.values.apass}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isInvalid={formik.touched.apass && formik.errors.apass}
                                        />
                                        <p className={"text-danger pt-1 m-0"} style={{height: '1.5rem'}}>
                                            {
                                                (formik.touched.apass && formik.errors.apass) &&
                                                <span>{formik.errors.apass}</span>
                                            }
                                        </p>
                                    </FloatingLabel>
                                    <InputGroup>
                                        <FloatingLabel controlId={"floatingNewPassword"} label={"Nueva Contraseña"}
                                                       bsPrefix={"form-floating text-gray-700"}>
                                            <Form.Control
                                                type={showNewP ? 'text' : 'password'}
                                                tabIndex={2}
                                                autoComplete={'off'}
                                                placeholder="Password"
                                                className={"form-control form-control-solid"}
                                                name="npass"
                                                value={formik.values.npass}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={formik.touched.npass && formik.errors.npass}
                                            />
                                        </FloatingLabel>
                                        <InputGroup.Text className={'border-0 p-0'}>
                                            <button type={'button'} className={'btn btn-icon pass'} tabIndex={3}
                                                    onClick={() => setShowNewP(!showNewP)}>
                                                <i className={"bi bi-eye fs-6 text-primary"}></i>
                                            </button>
                                        </InputGroup.Text>
                                    </InputGroup>
                                    <p className={"text-danger pt-1 mb-5"} style={{height: '1.5rem'}}>
                                        {
                                            (formik.touched.npass && formik.errors.npass) &&
                                            <span>{formik.errors.npass}</span>
                                        }
                                    </p>
                                    <InputGroup>
                                        <FloatingLabel controlId={"floatingConfirmPassword"}
                                                       label={"Confirmar Contraseña"}
                                                       bsPrefix={'form-floating text-gray-700'}>
                                            <Form.Control
                                                type={showConfirmP ? "text" : "password"}
                                                tabIndex={4}
                                                autoComplete={'off'}
                                                placeholder="Confirmar contraseña"
                                                className={"form-control form-control-solid"}
                                                name="cpass"
                                                value={formik.values.cpass}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={formik.touched.cpass && formik.errors.cpass}
                                            ></Form.Control>
                                        </FloatingLabel>
                                        <InputGroup.Text className={"border-0 p-0"}>
                                            <button type={'button'} className={'btn btn-icon pass'} tabIndex={5}
                                                    onClick={() => setShowConfirmP(!showConfirmP)}>
                                                <i className={"bi bi-eye fs-6 text-primary"}></i>
                                            </button>
                                        </InputGroup.Text>
                                    </InputGroup>
                                    <p className={"text-danger pt-1 mb-5"} style={{height: '1.5rem'}}>
                                        {
                                            (formik.touched.cpass && formik.errors.cpass) &&
                                            <span>{formik.errors.cpass}</span>
                                        }
                                    </p>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex mt-4">
                        <button
                            type="button"
                            tabIndex={6}
                            onClick={() => {
                                setShow(false)
                                formik.resetForm();
                            }}
                            className="btn btn-secondary mx-4"
                        >
                            Cancelar
                        </button>
                        <button
                            form={"changePassword"}
                            tabIndex={7}
                            type="submit"
                            className="btn btn-primary mx-4"
                            disabled={Object.keys(formik.errors).length > 0}
                        >
                            Actualizar contraseña
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}
